import React from 'react';

const BoldChunkySvg = (props) => (
    <svg
        className="bold-chunky_svg__eds-icon--bold-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bold-chunky_svg__eds-icon--bold-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9 12.9h3c2.1 0 3.3.6 3.3 2.2 0 1.5-.9 2.2-3 2.2H8.9v-4.4zm0-6.1h2.9c2.1 0 3 .5 3 2s-1 2-3 2H8.9v-4zm3.5 12.6c3 0 5.2-1.3 5.2-4.1 0-2.3-1.2-3.3-3.1-3.6 1.5-.3 2.6-1.3 2.6-3.4 0-2.7-2.2-3.7-5.2-3.7H6.4v14.8h6z"
        />
    </svg>
);

BoldChunkySvg.displayName = 'BoldChunkySvg';
export default BoldChunkySvg;
